import { render, staticRenderFns } from "./Footer-mobile.vue?vue&type=template&id=551fa3c4"
import script from "./Footer-mobile.vue?vue&type=script&lang=js"
export * from "./Footer-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports